export default __webpack_public_path__ + "static/media/clem-onojeghuo-1.9192314d.jpg";